import type { FlowDesignForm } from './flow-design.form';

export type ProductId = 'idv' | 'poa' | 'bank' | 'affordability' | 'aml' | 'card';

export type FlowDocumentTypes = {
  id: boolean;
  passport: boolean;
  residence: boolean;
  drivingLicense: boolean;
};

export const defaultFlowDocumentTypes: FlowDocumentTypes = {
  id: true,
  passport: true,
  residence: false,
  drivingLicense: false,
};

export type PoaDocumentTypes = {
  invoice: boolean;
  bill: boolean;
  bank: boolean;
};

export const defaultPoaDocumentTypes: PoaDocumentTypes = {
  invoice: true,
  bill: true,
  bank: true,
};

export type NewFlowWizardState = {
  flowName: string;
  serverUrl: string;
  customerId: string;
  incodeClientId: string;
  selectedProducts: ProductId[];
  documentTypes: FlowDocumentTypes;
  poaDocumentTypes: PoaDocumentTypes;
  flowDesign: FlowDesignForm;
};
